import { Col, Input, InputProps, Row, Select } from 'antd';
import React, { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { PhoneNumber } from '../../helpers/utils';
import { countryCodeFlag, countryCodes } from './pre-dial';

const { Option } = Select;

interface PhoneInputProps extends InputProps {
  currentValue: PhoneNumber | undefined;
  onUpdate: (value: PhoneNumber | undefined) => void;
}

export const PhoneInput: FC<PhoneInputProps> = ({ currentValue, onUpdate, ...props }) => {
  const { formatMessage } = useIntl();

  const [searchQuery, setSearchQuery] = useState<string>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if (reg.test(inputValue) || inputValue === '' || inputValue === '-') {
      onUpdate({ ...currentValue, number: Number(inputValue) });
    }
    props.onChange?.(e);
  };

  const searchQueryClean = searchQuery?.replace('+', '')?.toLowerCase() || '';

  return (
    <Input.Group size="large">
      <Row gutter={6} wrap={false}>
        <Col flex="140px">
          {/* @ts-ignore */}
          <Select
            {...props}
            allowClear
            showSearch
            size={'large'}
            searchValue={searchQuery}
            onSearch={setSearchQuery}
            style={{ width: '100%' }}
            value={currentValue?.countryCode}
            placeholder={formatMessage({
              id: 'signup.phone.pre-dial.placeholder',
            })}
            onClear={() => {
              setSearchQuery(undefined);
            }}
            onChange={(value) => {
              setSearchQuery(undefined);
              // @ts-ignore
              onUpdate({ ...currentValue, countryCode: value as number });
            }}
            filterOption={false}
          >
            {countryCodes
              ?.filter(
                (countryCode) =>
                  !searchQuery ||
                  countryCode.country.toLowerCase().includes(searchQueryClean) ||
                  countryCode.short.toLowerCase().includes(searchQueryClean) ||
                  countryCode.code.toString(10).includes(searchQueryClean),
              )
              .map((countryCode) => (
                <Option
                  key={`${countryCode.code}|${countryCode.short}`}
                  style={{ fontSize: '1.2em' }}
                  value={countryCode.code}
                >
                  {countryCodeFlag(countryCode.short)}
                  {` (${countryCode.short.toUpperCase()}) +${countryCode.code}`}
                </Option>
              ))}
          </Select>
        </Col>
        <Col flex="auto">
          <Input
            {...props}
            type={'tel'}
            style={{ width: '100%' }}
            value={currentValue?.number}
            placeholder={formatMessage({
              id: 'signup.phone.number.placeholder',
            })}
            onChange={handleChange}
          />
        </Col>
      </Row>
    </Input.Group>
  );
};
